<template>
  <form @submit.prevent="submit">
    <input v-model="name" placeholder="Name" />
    <input v-model="email" placeholder="Email" />
    <input type="password" v-model="password" placeholder="Password" />
    <button type="submit">Register</button>
  </form>
</template>

<script>
import { ref } from 'vue';
import axios from 'axios';

export default {
  setup() {
    const name = ref('');
    const email = ref('');
    const password = ref('');

    const submit = () => {
      axios.post('/api/register', {
        name: name.value,
        email: email.value,
        password: password.value,
        //password_confirmation: this.password_confirmation,
      })
          .then(response => {
            window.location.href = '/#/';
          })
          .catch(error => {
            console.error('Error registering:', error);
          });
    };

    return {
      name,
      email,
      password,
      submit,
    };
  },
};
</script>